import styled from "styled-components";

export const Icon = styled.img`
    width: 24px;
    height: 24px;
    margin-right: 8px;
    filter: hue-rotate(180deg) saturate(500%);
`;
